export default __webpack_public_path__ + "assets/fonts/Nunito-Black-bfa5590b.woff2";